import { Action } from '@ngrx/store';

import { UserInterface } from '../../models';
import { ErgoTeamMemberInterface } from '../../models/ergo-team-member.model';

import { UserActionType } from './user-action-type.enum';

export class CreateUser implements Action {
  public readonly type: UserActionType = UserActionType.CreateUser;

  constructor(public readonly payload: UserInterface) {}
}

export class CreateUserCompleted implements Action {
  public readonly type: UserActionType = UserActionType.CreateUserCompleted;

  constructor(public readonly payload: UserInterface) {}
}

export class CreateUserFailed implements Action {
  public readonly type: UserActionType = UserActionType.CreateUserFailed;

  constructor(public readonly payload: string) {}
}

export class AddErgoTeamMember implements Action {
  public readonly type: UserActionType = UserActionType.AddErgoTeamMember;

  constructor(public readonly payload: { teamMember: ErgoTeamMemberInterface, user: UserInterface }) {}
}

export class AddErgoTeamMemberCompleted implements Action {
  public readonly type: UserActionType = UserActionType.AddErgoTeamMemberCompleted;

  constructor(public readonly payload: ErgoTeamMemberInterface[]) {}
}

export class AddErgoTeamMemberFailed implements Action {
  public readonly type: UserActionType = UserActionType.AddErgoTeamMemberFailed;

  constructor(public readonly payload: UserInterface) {}
}
